import { MapPin } from "lucide-react";
import { Carte, Indisponible, Ligne, isErreur, nombre } from "./shared";

export default function LocalisationCard({ data, parcelId }) {
  return (
    <Carte titre="Localisation" numero="2" icon={MapPin} testId="fiche-localisation">
      {isErreur(data) ? <Indisponible /> : (
        <>
          <Ligne label="Identifiant"><span className="font-mono text-xs">{parcelId}</span></Ligne>
          <Ligne label="Commune" v={data.commune}
            format={(c) => (data.code_insee ? `${c} (${data.code_insee.valeur})` : c)} />
          <Ligne label="Cadastre" v={data.cadastre} format={(c) => c.libelle} />
          <Ligne label="RPG" v={data.rpg} format={(r) => `Parcelle ${r.id}${r.code_culture ? ` · ${r.code_culture}` : ""}`} />
          <Ligne label="Surface calculée" v={data.surface_calculee} />
          {data.surface_rpg && <Ligne label="Surface RPG" v={data.surface_rpg} />}
          <Ligne label="Centre GPS" v={data.centre} format={(c) => `${c.lat.toFixed(5)}, ${c.lon.toFixed(5)}`} />
          <Ligne label="Altitude" v={data.altitude} />
          <Ligne label="Pente" v={data.pente} />
          <Ligne label="Cours d'eau le plus proche" v={data.cours_eau}
            format={(c) => `${nombre(c.distance_m, 0)} m${c.nom ? ` · ${c.nom}` : ""}`} />
          {data.contour_origine && (
            <Ligne label="Contour">Modifié, contour d'origine conservé</Ligne>
          )}
        </>
      )}
    </Carte>
  );
}
